module.exports = __webpack_public_path__ + "img/code2.7b39f2a1.png";